var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMight = function SvgMight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1395.26,
    height: 1459,
    viewBox: "-10 0 1395.26 1459"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1365.63 636q-14 34-51.5 81.5t-91.5 95.5q-58 52-124 90 5 57 16.5 171t17.5 171q-52 69-122 122-80 60-175 92-9-85-27.5-251t-27.5-247q17-9 78-43t94-52l-29-95q-56 19-111 29-63 11-125 13-64-2-124-13-57-11-112-29l-29 95q29 16 86.5 48t85.5 47q-9 83-27.5 249t-27.5 249q-96-32-175-92-69-52-122-122 6-55 17.5-169t16.5-173q-67-39-124-90-54-48-91.5-95.5T9.63 636q-51-128 30.5-301.5T319.63 0q-25 140-45 236-8 39-11.5 59t-6 54.5 5 63.5 23.5 56q33 57 100 90 67-100 154-185 69-68 148-125 79 56 149 125 86 85 153 185 68-34 101-90 16-27 23-56t4.5-63.5-5.5-54.5-11-59q-21-96-46-236 198 161 279.5 334.5t30.5 301.5"
  })));
};
export default SvgMight;